import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IEmployeeProfileItem extends IModel {
	name?: string;
	value?: string;
}

const profileItemFactory = modelFactory.createFactory<IEmployeeProfileItem>('EmployeeProfileItem', _.assign({}, model, {
	name: {
		rules: validator.string()
	},
	value: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	}
}));

export default profileItemFactory;